import { render } from "./matlab.vue?vue&type=template&id=64a6bac6&scoped=true"
import script from "./matlab.vue?vue&type=script&lang=js"
export * from "./matlab.vue?vue&type=script&lang=js"

import "./matlab.vue?vue&type=style&index=0&id=64a6bac6&scoped=true&lang=css"
import "./matlab.vue?vue&type=style&index=1&id=64a6bac6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a6bac6"]])

export default __exports__